'use strict';

angular.module('theme').directive('stickyNav', function ($window) {
	return {
		restrict: 'A',
		link: function (scope, $element, attr) {

			var win = $window;
			var $win = angular.element($window);
			var doc = win.document;
			var elementTop = $element[0].offsetTop;

			var stickyClass = attr.stickyNav || 'navbar-fixed-top';

			var check = _.throttle(function () {
				var scrollTop = (win.pageYOffset || doc.scrollTop || 0);

				if (scrollTop >= elementTop) {
					$element.addClass(stickyClass);
				} else {
					$element.removeClass(stickyClass);
				}
			}, 200);

			$win.on('scroll', check);
			$win.on('resize', check);

			check();
		}
	};
});
